"use strict";
const authStore = require("stores/new-auth");
const { observer } = require("mobx-react");
const Link = require("../link");

const MedicationsLink = () => {
  let { user } = authStore;
  if (!user.canReadMedications) return null;

  return (
    <li className="SidebarNav-item">
      <Link to="/medications">
        <span className="SidebarNavLink-icon">
          <span aria-hidden={true} className="icon fa fa-user-md" />
        </span>
        <span className="SidebarNavLink-text">Medications</span>
      </Link>
    </li>
  );
};

module.exports = observer(MedicationsLink);
